import {TabId} from 'src/modules/tabs-panel/typedefs';

type Params = {
    pathName: TabId,
};

export const createMainTabbRoutePath = (params: Params) => {
    return `/${params.pathName}`;
};
